import React from "react";
import { Link } from "react-router-dom";
import TextareaAutosize from "react-textarea-autosize";
import { Button, FormGroup, Row, Col, Label, Container } from "reactstrap";
import SiteSummaryView from "components/SiteSummaryView";

import constants from "../../constants";
import api from "../../api";
import "./index.css";
import MapComponent from "../MapComponent";
import ExternalSiteEdit from "../ExternalSiteEdit";

// The Roster component matches one of two different routes
// depending on the full pathname
export default class ExternalSiteDetailScreen extends React.Component {
  constructor(props) {
    super(props);
    this.externalSiteId =
      parseInt(this.props.match.params.external_site_id, 10) || 0;
    this.state = {
      site: null,
      labelNames: [],
      isLoading: false,
      isMapObjectClicked: false,
      initialViewState: {
        longitude: 0,
        latitude: 0,
        zoom: 15,
        pitch: 0,
        bearing: 0
      },
      isRejecting: false
    };
    this.onViewStateChange = this.onViewStateChange.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.getSiteDetail();
  }
  componentDidMount = () => {};
  getSiteDetail() {
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "get",
      uri: `external_site/${this.externalSiteId}`,
      success: response => {
        const site = response.result;
        this.setState({
          site,
          labelNames: response.label_columns,
          viewState: {
            longitude: site.longitude,
            latitude: site.latitude,
            zoom: 15,
            pitch: 0,
            bearing: 0
          }
        });
        this.setState({ isLoading: false });
      },
      error: error => {
        console.error(error);
        this.setState({ isLoading: false });
      }
    });
  }
  changeToChecking = () => {
    const confirmation = window.confirm(
      `Bạn sẽ đưa mặt bằng này thành trạng thái Đang kiểm tra`
    );
    if (!confirmation) return;
    const { site } = this.state;
    site.status = "checking";
    this.setState({ site }, this.updateSite);
  }
  changeToSaveForlater = () => {
    const confirmation = window.confirm(
      `Bạn sẽ đưa mặt bằng này thành trạng thái Xem lại sau`
    );
    if (!confirmation) return;
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "put",
      uri: `external_site/${site.id}/save_for_later`,
      success: async response => {
        if (response.result) {
          site.status = response.result.status;
          this.setState({
            site,
            isLoading: false
          });
        }
      },
      error: error => {
        alert(error.message);
        this.setState({ isLoading: false });
      }
    });
  }
  changeToApproved = () => {
    const confirmation = window.confirm(
      `Bạn sẽ đưa mặt bằng này thành trạng thái Duyệt`
    );
    if (!confirmation) return;
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "put",
      uri: `external_site/${site.id}/approved`,
      success: async response => {
        if (response.result) {
          site.status = response.result.status;
          this.setState({
            site,
            isLoading: false
          });
        }
      },
      error: error => {
        alert(error.message);
        this.setState({ isLoading: false });
      }
    });
  }
  changeToRejected = () => {
    const confirmation = window.confirm(
      `Bạn sẽ đưa mặt bằng này thành trạng thái Từ chối`
    );
    if (!confirmation) return;
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "put",
      uri: `external_site/${site.id}/rejected`,
      body: {
        reject_reason: site.reject_reason
      },
      success: async response => {
        if (response.result) {
          site.status = response.result.status;
          this.setState({
            site,
            isLoading: false,
            isRejecting: false
          });
        }
      },
      error: error => {
        alert(error.msg);
        this.setState({ isLoading: false });
      }
    });
  }
  updateSite = () => {
    const { site } = this.state;
    this.setState({ isLoading: true });
    api.fetchAPI({
      method: "put",
      uri: `external_site/${site.id}`,
      body: site,
      success: async response => {
        if (response.result) {
          this.setState({
            site,
            isLoading: false
          });
        }
      },
      error: error => {
        alert(error.msg);
        this.setState({ isLoading: false });
      }
    });
  }
  updateAttr(attribute, value) {
    const { site } = this.state;
    site[attribute] = value;
    this.setState({ site });
  }
  onViewStateChange({ viewState }) {
    this.setState({ viewState });
  }
  render() {
    const {
      site,
      labelNames,
      isRejecting,
      viewState,
      isMapObjectClicked,
      hoveredObject
    } = this.state;
    console.log(this.state.site);
    if (!site) return null;
    // if (isLoading) return <div>Đang tải...</div>;

    let validLatLng = true;
    // Validate lat lng to avoid app crashing
    if (site.latitude < -90 || site.latitude > 90) {
      validLatLng = false;
    }

    if (site.longitude < -180 || site.longitude > 180) {
      validLatLng = false;
    }
    return (
      <Container>
        <div className="site-detail__wrapper">
          <div className="site-detail_summary">
            <div className="site-detail_site-name">
              {site.brand && site.brand && site.brand.brand_logo_image && (
                <img
                  src={site.brand.brand_logo_image}
                  alt={site.brand.name}
                  className="site-detail_brand-logo"
                />
              )}
              {site.address_number && (
                <span className="site-detail__site-name">
                  {site.address_number} {site.street_name}
                </span>
              )}
              {site.status && (
                <span className={`site-status-label ${site.status}`}>
                  {site.status}
                </span>
              )}
            </div>
            <p className="site-detail__full-address">
              {site.address_number && site.street_name && (
                <span>
                  {site.address_number} {site.street_name}, {site.ward ? site.ward.name : ""},{" "}
                  {site.district? site.district.name : ""}, {site.city ? site.city.name : site.city}
                </span>
              )}
            </p>
          </div>
          <p className="site-detail_metric-single">
            <b>Diện tích</b>: {site.area} m2
          </p>
          <Row>
            <Col xs={12}>
              <div className="site-detail__main-controls">
                {site.permissions?.includes("can_put") && site.status === "new" && (
                  <Button
                    onClick={this.changeToChecking}
                    color="primary"
                    className="site-detail__button-control"
                  >
                    Đang kiểm tra
                  </Button>
                )}
                {site.permissions?.includes("can_put") &&
                  (site.status === "new" ||
                    site.status === "save-for-later" ||
                    site.status === "checking") && (
                    <div>
                      <Button
                        tag={Link}
                        to={`/external_site/${site.id}/edit`}
                        onClick={() => {}}
                        color="info"
                        className="site-detail__button-control"
                      >
                        Chỉnh sửa
                      </Button>
                    </div>
                  )}
                {site.permissions?.includes("can_put") &&
                  (site.status === "new" || site.status === "checking") && (
                    <div>
                      <Button
                        onClick={this.changeToSaveForlater}
                        color="info"
                        className="site-detail__button-control"
                      >
                        Xem lại sau
                      </Button>
                    </div>
                  )}
                {site.permissions?.includes("can_put") &&
                  site.status === "checking" && (
                    <div>
                      <Button
                        onClick={this.changeToApproved}
                        color="success"
                        className="site-detail__button-control"
                      >
                        Duyệt
                      </Button>
                    </div>
                  )}
                {site.permissions?.includes("can_put") &&
                  (site.status === "new" || site.status === "checking") && (
                    <div>
                      <Button
                        onClick={() => {
                          this.setState({ isRejecting: true });
                        }}
                        color="info"
                        className="site-detail__button-control"
                      >
                        Từ chối
                      </Button>
                    </div>
                  )}
              </div>
            </Col>
          </Row>
          <Row>
            {isRejecting && (
              <Col xs={12} className="site-detail__rejection-reason-container">
                <Label>Lý do từ chối</Label>
                <FormGroup>
                  <TextareaAutosize
                    type="textarea"
                    className="custom-textarea"
                    onChange={e =>
                      this.updateAttr("reject_reason", e.target.value)
                    }
                    value={site.reject_reason}
                    minRows={3}
                  />
                </FormGroup>
                <FormGroup>
                  <Button
                    onClick={this.changeToRejected}
                    color="danger"
                  >
                    Tiếp tục
                  </Button>{" "}
                  <Button
                    onClick={() => this.setState({ isRejecting: false })}
                    color="secondary"
                  >
                    Quay lại
                  </Button>
                </FormGroup>
              </Col>
            )}
          </Row>
          <Row className="site-detail__images">
            {constants.EXTERNAL_SITE_IMAGE_ATTRIBUTES.map((imageAttribute) => (
              <Col xs={12} sm={6} key={imageAttribute}>
                {site.photos && (
                  <div className="site-edit__img-container">
                    <Label>{labelNames[imageAttribute]}</Label>
                    {site.photos[imageAttribute] &&
                      site.photos[imageAttribute]["url"] && (
                        <img
                          className="site-edit__img"
                          src={site.photos[imageAttribute]["url"]}
                        />
                      )}
                    {site.photos[imageAttribute] &&
                      site.photos[imageAttribute]["caption_text"] && (
                        <p className="site-edit__caption">
                          {site.photos[imageAttribute]["caption_text"]}
                        </p>
                      )}
                  </div>
                )}
              </Col>
            ))}
          </Row>
          {validLatLng && site.latitude && site.longitude ? (
            <Row>
              <Col xs={12}>
                {!isMapObjectClicked ? (
                  <div>
                    <div className="site-detail__map">
                      <MapComponent
                        latitude={viewState.latitude}
                        longitude={viewState.longitude}
                        scanningRadius={2}
                      />
                    </div>
                  </div>
                ) : (
                  <SiteSummaryView
                    site={hoveredObject}
                    onBackClick={() =>
                      this.setState({ isMapObjectClicked: false })
                    }
                  />
                )}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={12}>
                <p>Map will not show due to missing or invalid lat, lng...</p>
              </Col>
            </Row>
          )}
          <ExternalSiteEdit
            match={{ params: { external_site_id: site.id } }}
            site={site}
            labelNames={labelNames}
            isView
          />
        </div>
      </Container>
    );
  }
}
